import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-37605826"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "file-tab"
};
const _hoisted_2 = {
  class: "file-tab-nav"
};
const _hoisted_3 = {
  class: "file-tab-button"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "qh-icon-new"
}, null, -1));
const _hoisted_5 = [_hoisted_4];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "qh-icon-cloud"
}, null, -1));
const _hoisted_7 = [_hoisted_6];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "qh-icon-moreandroid"
}, null, -1));
const _hoisted_9 = [_hoisted_8];
const _hoisted_10 = {
  key: 0,
  class: "file-tab-more"
};
const _hoisted_11 = {
  key: 0,
  class: "file-tab-option"
};
const _hoisted_12 = {
  href: "javascript:;"
};
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { TASK_TYPE_IDS } from '@remote/constant';
import { useDeviceStore } from '@remote/store/device';
import router from '@remote/router';
import { stat } from '@remote/utils/stat';
import { newToast } from '@remote/utils';
import { openDialogScrapeHint } from '@remote/utils/dialog';
import { isTheDateToday } from '@shared/utils';
export default /*#__PURE__*/_defineComponent({
  __name: 'FileTabPlus',
  setup(__props) {
    const store = useStore();
    const deviceStore = useDeviceStore();
    const showMoreTab = ref(false);
    const tasks = computed(() => {
      return store.state.tasks;
    });
    const isSelect = computed(() => {
      return store.state.isSelect;
    });
    const selects = computed(() => {
      return store.state.selects;
    });
    const taskType = computed(() => {
      return store.state.taskType;
    });
    const curList = computed(() => {
      return store.getters.curList;
    });
    const all = computed(() => {
      return store.state.all;
    });
    const curAllSelect = computed(() => {
      return store.getters.curAllSelect;
    });
    const isLogin = computed(() => {
      return store.getters.isLogin;
    });
    const tasksNum = computed(() => {
      // return tasks.value.filter(id => this.all[id].phase !== 'PHASE_TYPE_ERROR').length
      const total = tasks.value.length > 0 ? tasks.value.length : '';
      return total;
    });
    const status = computed(() => {
      var _deviceStore$currentD;
      return ((_deviceStore$currentD = deviceStore.currentDeviceRef) === null || _deviceStore$currentD === void 0 ? void 0 : _deviceStore$currentD.runnerTaskRef.phase) === 'PHASE_TYPE_RUNNING';
    });
    const selectNum = computed(() => {
      return selects.value.length;
    });
    const downloadOrPause = (id, action, willToast) => {
      store.dispatch('actionTask', {
        id,
        action,
        willToast
      });
    };
    const handelAllTask = async type => {
      if (tasks.value.length <= 0) return;
      for (let i = 0; i < tasks.value.length; i++) {
        const task = tasks.value[i];
        const willToast = i === tasks.value.length - 1;
        await downloadOrPause(task, type, willToast);
      }
    };
    const handelActionTabClick = val => {
      switch (val) {
        case 'allStart':
          console.log('全部开始');
          handelAllTask('running');
          break;
        case 'allStop':
          console.log('全部暂停');
          handelAllTask('pause');
          break;
        default:
          break;
      }
      showMoreTab.value = false;
    };
    const handleSelect = () => {
      showMoreTab.value = false;
      if (curList.value.length === 0) return store.commit('toast', '暂无任务可以操作');
      store.commit('update', {
        isSelect: true
      });
    };
    const changeMoreTab = () => {
      if (!status.value) {
        newToast({
          message: '设备未连接'
        });
        return;
      }
      showMoreTab.value = !showMoreTab.value;
    };
    const handleCancel = () => {
      store.commit('update', {
        isSelect: false,
        selects: []
      });
    };
    const checkDialogScrapeHintShow = async () => {
      var _deviceStore$currentN, _deviceStore$currentN2;
      const deviceStore = useDeviceStore();
      const hasInitCinema = (_deviceStore$currentN = deviceStore.currentNFOInstance) === null || _deviceStore$currentN === void 0 ? void 0 : _deviceStore$currentN.hasInitCinema;
      const hasInitLocalState = (_deviceStore$currentN2 = deviceStore.currentNFOInstance) === null || _deviceStore$currentN2 === void 0 ? void 0 : _deviceStore$currentN2.hasInitLocalState;
      const todayTask = curList.value.map(i => all.value[i]).find(i => {
        return isTheDateToday(new Date(i.updated_time));
      });
      console.log('hasTodayTask', todayTask, 'hasInitCinema', hasInitCinema);
      if (todayTask && hasInitLocalState && !hasInitCinema) {
        var _deviceStore$currentD2, _deviceStore$currentD3;
        if (!((_deviceStore$currentD2 = deviceStore.currentDeviceRef) !== null && _deviceStore$currentD2 !== void 0 && _deviceStore$currentD2.util.isVersionSmallerThan('3.20.0')) && ((_deviceStore$currentD3 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD3 === void 0 || (_deviceStore$currentD3 = _deviceStore$currentD3.baseConfig) === null || _deviceStore$currentD3 === void 0 || (_deviceStore$currentD3 = _deviceStore$currentD3.nfo_config) === null || _deviceStore$currentD3 === void 0 ? void 0 : _deviceStore$currentD3.is_disabled) === false) {
          var _deviceStore$currentD4, _deviceStore$currentD5, _deviceStore$currentD6;
          const uid = (_deviceStore$currentD4 = (_deviceStore$currentD5 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD5 === void 0 || (_deviceStore$currentD5 = _deviceStore$currentD5.deviceInfoRef.user) === null || _deviceStore$currentD5 === void 0 ? void 0 : _deviceStore$currentD5.id) !== null && _deviceStore$currentD4 !== void 0 ? _deviceStore$currentD4 : '';
          const canShow = await ((_deviceStore$currentD6 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD6 === void 0 ? void 0 : _deviceStore$currentD6.dialogManager.canDialogShow({
            uid,
            dialogID: 'SCRAPE_HINT'
          }));
          console.log('hasTodayTask canshow', canShow);
          if (canShow) {
            var _deviceStore$currentD7;
            (_deviceStore$currentD7 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD7 === void 0 ? void 0 : _deviceStore$currentD7.dialogManager.dialogShow({
              uid,
              dialogID: 'SCRAPE_HINT'
            });
            openDialogScrapeHint({
              theme: 'light',
              scene: 'local'
            });
          }
        }
      }
    };
    const onTab = tab => {
      store.commit('update', {
        selects: [],
        taskType: TASK_TYPE_IDS[tab]
      });
      console.log('onTab', tab);
      if (tab > 1) {
        store.dispatch('getFiles', {
          type: TASK_TYPE_IDS[tab]
        });
      } else {
        store.dispatch('getTasks', {
          type: TASK_TYPE_IDS[tab]
        });
      }
      if (tab === 1) {
        checkDialogScrapeHintShow();
      }
    };
    const handleAllSel = () => {
      let list = [];
      if (!curAllSelect.value) {
        list = [...curList.value];
      }
      store.commit('update', {
        selects: list
      });
    };
    const callAppUpload = async () => {
      if (!isLogin.value) return;
      stat({
        action: 'create_task_btn_click',
        data: {
          position: 'add'
        }
      });
      if (!status.value) return store.commit('toast', '设备未连接');
      store.commit('update', {
        createFrom: 'add'
      });
      router.push({
        path: '/upload/',
        query: router.currentRoute.value.query
      });
    };
    const callAppDown = async () => {
      if (!isLogin.value) return;
      stat({
        action: 'getback_btn_click'
      });
      if (!status.value) return store.commit('toast', '设备未连接');
      router.push({
        path: '/files/',
        query: router.currentRoute.value.query
      });
    };
    watch(curList, list => {
      if (list && list.length === 0) handleCancel();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("nav", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", {
        class: _normalizeClass({
          'is-active': taskType.value === 'ing'
        }),
        onClick: _cache[0] || (_cache[0] = $event => onTab(0))
      }, [_createTextVNode("下载中 "), _withDirectives(_createElementVNode("sup", {
        class: "file-tab__number"
      }, _toDisplayString(tasksNum.value), 513), [[_vShow, status.value]])], 2), _createElementVNode("span", {
        class: _normalizeClass({
          'is-active': taskType.value === 'done' || taskType.value === 'bt'
        }),
        onClick: _cache[1] || (_cache[1] = $event => onTab(1))
      }, "已完成", 2), _createElementVNode("div", _hoisted_3, [_createElementVNode("a", {
        href: "javascript:;",
        onClick: callAppUpload,
        class: _normalizeClass(["file__button", {
          'is-disabled': !status.value
        }])
      }, _hoisted_5, 2), _createElementVNode("a", {
        href: "javascript:;",
        onClick: callAppDown,
        class: _normalizeClass(["file__button", {
          'is-disabled': !status.value
        }])
      }, _hoisted_7, 2), _createElementVNode("a", {
        href: "javascript:;",
        onClick: changeMoreTab,
        class: _normalizeClass(["file__button", {
          'is-disabled': !status.value
        }])
      }, _hoisted_9, 2), showMoreTab.value ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = _withModifiers($event => handelActionTabClick('allStart'), ["stop"])),
        class: "file-more-item"
      }, " 全部开始 "), _createElementVNode("div", {
        onClick: _cache[3] || (_cache[3] = _withModifiers($event => handelActionTabClick('allStop'), ["stop"])),
        class: "file-more-item"
      }, " 全部暂停 "), _createElementVNode("div", {
        onClick: handleSelect,
        class: "file-more-item"
      }, " 多选操作 "), _createElementVNode("div", {
        class: "cancel",
        onClick: _cache[4] || (_cache[4] = $event => showMoreTab.value = false)
      })])) : _createCommentVNode("", true)])]), isSelect.value ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("a", {
        href: "javascript:;",
        onClick: handleCancel
      }, "取消"), _createElementVNode("a", _hoisted_12, [_createTextVNode("已选择"), _createElementVNode("span", null, _toDisplayString(selectNum.value), 1), _createTextVNode("个")]), _createElementVNode("a", {
        href: "javascript:;",
        style: {
          "color": "#3F85FF"
        },
        onClick: handleAllSel
      }, _toDisplayString(curAllSelect.value ? '取消全选' : '全选'), 1)])) : _createCommentVNode("", true)]);
    };
  }
});